import { isFunction } from 'lodash';

function filterExclusion() {
  'ngInject';
  return {
    restrict: 'E',
    scope: {},
    template: require('./filter-exclusion.html'),
    controllerAs: 'vm',
    controller: 'FilterExclusionController',
    bindToController: {
      excluded: '=',
      onChange: '&?'
    }
  };
}

function FilterExclusionController() {
  'ngInject';
  const vm = this;
  vm.update = update;

  /**
   * @param {Boolean} value
   */
  function update(value) {
    if (vm.onChange && isFunction(vm.onChange)) {
      vm.onChange({
        $event: {value}
      });
    }
  }
}

export {filterExclusion, FilterExclusionController};
